import { isNil } from "@hopper-ui/components";
import { MixpanelEventName, MixpanelProperty } from "@sg-protect/shell";
import type { DOMEventTelemetryHandler } from "./domEventTracker.ts";
import { getModalInformation, getTelemetryName } from "./utils.ts";

const handleEvent: DOMEventTelemetryHandler<"auxclick">["handleEvent"] = (evt, onEvent) => {
    const anchor = (evt.target as HTMLElement).closest("a")!;
    const textNode = anchor.querySelector("span");
    const text = getTelemetryName(textNode ?? anchor);
    const modalInformation = getModalInformation(anchor);

    const eventName: MixpanelEventName = anchor.className?.includes("hop-LinkButton")
        ? MixpanelEventName.ButtonClicked
        : MixpanelEventName.LinkClicked;

    void onEvent(eventName, {
        [MixpanelProperty.Name]: text,
        [MixpanelProperty.Modal]: modalInformation
    });
};

export const anchorClickHandler: DOMEventTelemetryHandler<"click"> = {
    isHandling: evt => {
        return !isNil((evt.target as HTMLElement)?.closest("a"));
    },
    handleEvent
};

// If the middleclick is used on a link
export const anchorAuxClickHandler: DOMEventTelemetryHandler<"auxclick"> = {
    isHandling: evt => {
        return !isNil((evt.target as HTMLElement)?.closest("a"));
    },
    handleEvent
};
